import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { PagerTitle } from '../../../../global';
import { NgSwitch, NgSwitchCase, NgFor, NgTemplateOutlet } from '@angular/common';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { AccessDirective } from '../../../directives/has-access.directive';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-pager',
    templateUrl: './pager.component.html',
    styleUrls: ['./pager.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgSwitch, NgSwitchCase, MatTabGroup, NgFor, AccessDirective, MatTab, MatTabContent, CdkScrollable, NgTemplateOutlet, TranslatePipe]
})
export class PagerComponent {
  @Input() public titles: Array<PagerTitle>;
  @Input() public pages: Array<any> = [];
  @Input() public maxHeight = 21.5;
  @Input() public disableMaxHeight = false;
  @Input() public disableElevation = false;
  @Input() public align: 'start' | 'center' | 'end' = 'center';
  @Input('selected')
  set setSelected(selectedPage: string){
    if(selectedPage){
      this.selectedIndex = this.titles.findIndex(value => value.search === selectedPage);
    }
  }

  @Output() public readonly pageChanged = new EventEmitter<number>();

  public selectedIndex: number = null;
}
